import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const getCoursesArrayService = async (userId) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.get(
			`${CONFIG.STUDENTURL}/api/v2/student/my-courses`,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
